module.exports = __webpack_public_path__ + "static/img/account_icon1.d0602af2.png";